export default __webpack_public_path__ + "static/media/vegas.48d93b68.jpeg";